$(function () {
  const $header = $('.section-header');
  const $nav = $('nav.product-page-nav');
  const $navWrapper = $nav.find('.nav-wrapper');
  const $navList = $nav.find('.nav-list-content');
  const $navToggle = $nav.find('.nav-toggle');
  const $navArrow = $nav.find('.product-page-nav-icon-arrow');
  const $navLinks = $('.nav-list a, .nav-list-content a');
  const $navLogo = $('.nav-logo');
  function handleNavVisibility() {
    let headerBottom = $header.length ? $header.offset().top + $header.outerHeight() : 0;
    let scrollY = $(window).scrollTop();
    let visible = scrollY >= 177;
    $nav.css({
      opacity: visible ? 1 : 0,
      'pointer-events': visible ? 'auto' : 'none',
    });
  }
  $(window).on('scroll', handleNavVisibility);
  handleNavVisibility();
  $navToggle.on('click', function (e) {
    e.stopPropagation();
    if ($navList.is(':hidden')) {
      $navList.css('display', 'flex');
      $navWrapper.css('height', 'auto');
      $navArrow.removeClass('svg-rotate');
    } else {
      $navList.hide();
      $navArrow.addClass('svg-rotate');
    }
  });
  $(document).on('click', function (e) {
    if (window.innerWidth <= 1023 && !$navList.is(':hidden')) {
      if (!$(e.target).closest($navList).length && !$(e.target).closest($navToggle).length) {
        $navList.hide();
        $navArrow.addClass('svg-rotate');
      }
    }
  });
  $(window).on('resize', function () {
    if (window.innerWidth > 1023) {
      $navList.css('display', '');
      $navArrow.addClass('svg-rotate');
    }
  });
  let $sections = $();
  $navLinks.each(function () {
    const href = $(this).attr('href');
    if (!href || href === '#') return;
    const $target = $(href);
    if ($target.length) {
      $sections = $sections.add($target);
    }
  });
  const firstLinkText = $navLinks.first().text().trim();
  $('.nav-highlight span').text(firstLinkText);
  $navLogo.on('click', function (e) {
    e.preventDefault();
    $(window).scrollTop(0);
    history.replaceState(null, '', window.location.pathname + window.location.search);
    $('.nav-highlight span').text(firstLinkText);
    $navLinks.removeClass('nav-active');
    if (window.innerWidth <= 1023 && !$navList.is(':hidden')) {
      $navList.hide();
      $navArrow.addClass('svg-rotate');
    }
  });
  $navLinks.on('click', function (e) {
    e.preventDefault();
    const target = $($(this).attr('href'));
    if (!target.length) return;
    $(window).scrollTop(target.offset().top - 60);
    if (window.innerWidth <= 1023 && !$navList.is(':hidden')) {
      $navList.hide();
      $navArrow.addClass('svg-rotate');
    }
  });
  $(window).on('scroll', function () {
    const scrollPos = $(document).scrollTop();
    if (scrollPos === 0) {
      $('.nav-highlight span').text(firstLinkText);
    }
    let currentId;
    $sections.each(function () {
      const sectionTop = $(this).offset().top - 70;
      if (scrollPos >= sectionTop) {
        currentId = this.id;
        const navTitle = $navLinks.filter(`[href="#${currentId}"]`).first().text().trim();
        $('.nav-highlight span').text(navTitle);
      }
    });
    $navLinks.removeClass('nav-active');
    $navLinks.each(function () {
      if ($(this).attr('href') === '#' + currentId) {
        $(this).addClass('nav-active');
      }
    });
  });
  $(window).trigger('scroll');
});
